module.exports = __webpack_public_path__ + "img/troca_para_editor_rich_text.62da164e.png";